/**
 * Tipos de planos disponíveis
 */
export type UserPlan = 'PLAN_BASIC' | 'PLAN_PLUS' | 'PLAN_PRO' | null;

/**
 * Determina o plano do usuário baseado nos grupos do Cognito
 * @param groups Array de grupos do Cognito
 * @returns O plano do usuário ou null se não encontrado
 */
export const getUserPlan = (groups: string[] | undefined | null): UserPlan => {
  if (!groups || !Array.isArray(groups)) {
    return null;
  }

  // Verifica se o usuário pertence a algum dos grupos de plano
  if (groups.includes('PLAN_PRO')) {
    return 'PLAN_PRO';
  }
  if (groups.includes('PLAN_PLUS')) {
    return 'PLAN_PLUS';
  }
  if (groups.includes('PLAN_BASIC')) {
    return 'PLAN_BASIC';
  }

  return null;
};

/**
 * Retorna o limite de empresas permitidas para um plano
 * @param plan Plano do usuário
 * @returns Limite de empresas ou null se ilimitado
 */
export const getCompanyLimit = (plan: UserPlan): number | null => {
  switch (plan) {
    case 'PLAN_BASIC':
      return 5;
    case 'PLAN_PLUS':
      return 50;
    case 'PLAN_PRO':
      return null; // Ilimitado
    default:
      return null;
  }
};

/**
 * Verifica se o usuário tem acesso à busca premium
 * @param plan Plano do usuário
 * @returns true se o usuário tem acesso, false caso contrário
 */
export const hasPremiumSearchAccess = (plan: UserPlan): boolean => {
  return plan === 'PLAN_PRO';
};

export const getPlanLabelFromGroups = (groups: string[] | undefined | null): string => {
  const plan = getUserPlan(groups);
  switch (plan) {
    case 'PLAN_BASIC':
      return 'Plano Básico';
    case 'PLAN_PLUS':
      return 'Plano Plus';
    case 'PLAN_PRO':
      return 'Plano Pró';
    default:
      return 'Plano Básico';
  }
};










